const Page404NotFound = () => {

   return (
    <>
      <div className="row align-items-center mb-3">
        <div className="col">
          <h2 className="mb-0">
            <i className="bi bi-exclamation-triangle-fill"></i>&nbsp;404
          </h2>
        </div>
      </div>
      {/*LISTE DES PUBLICATIONS */}
      <div className="App-row m-column align-items-center mt-3 align-items-lg-start">
        La page que vous cherchez n&apos;existe pas
      </div>
    </>
  );
};

export default Page404NotFound;
